import { useEffect, useState } from "react";

import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
} from "antd";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import DataTable from "./dataTable";
import PageHeader from "../../admin/pageHeader/pageheader";

function ClientIndex() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5); // Define the page size
  const [data, setData] = useState<any>([]);
  const [meta, setMeta] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  // const filterEmployee = async (values: any) => {
  //   try {
  //     setIsLoading(true);
  //     let obj = {
  //       query: form.getFieldValue("query"),
  //       type: values.type,
  //       fullName: values.fullName,
  //       // Email: "string",
  //       // department: "string",
  //       status: true,
  //     };
  //     const url = API.FILTER_EMPLOYEE;
  //     const response: any = await POST(url, obj);
  //     setData(response?.data);

  //     setMeta(response?.meta);
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const fetchHrclient = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_CLIENT;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrclient(page, pageSize);
  }, [page, pageSize]);

  const filterclient = async (values: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
        companyName: values.companyName,
      };
      const url = API.PAGENATION_CLIENT;
      const response: any = await POST(url, obj);
      setData(response?.data);

      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrclient(page, pageSize);
  }, [page, pageSize]);

  const submitHandler = async (values: any) => {
    try {
      let obj = {
        name: values.name,
        type: values.type,
        username: values.username,
        password: values.password,
        companyName: values.companyName,
        client_email: values.client_email,
        email_password: values.email_password,
        fb_username: values.fb_username,
        fb_password: values.fb_password,
        insta_username: values.insta_username,
        insta_password: values.insta_password,
        hostinger_username: values.hostinger_username,
        hostinger_password: values.hostinger_password,
        wrok_status: values.wrok_status,
        client_phone: values.client_phone,
        address: values.address,
        pincode: values.pincode,
        domain_username: values.domain_username,
        domain_password: values.domain_password,
        url: values.url,
        clientId: values.clientId,
        wrokstatus: values.wrokstatus,
        amount: Number(values.amount),
        start_date: values.start_date,
        end_date: values.end_date,
        linkedin_username: values.linkedin_username,
        whatsapp_client_phone: values.whatsapp_client_phone,
        linkedin_password: values.linkedin_password,
      };

      setIsLoading(true);
      const api = API.CLIENT_CREATE;
      const postRequest: any = await POST(api, obj);

      if (postRequest.status) {
        notification.success({ message: "client created successfully!" });
        setIsLoading(false);
        setIsModalOpen(false);
        form.resetFields();
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  return (
    <div>
      <PageHeader>
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginRight: "10px" }}
        >
          Create Client
        </Button>
      </PageHeader>
      <div>
        <Card>
          <Form form={form} onFinish={filterclient} layout="vertical">
            <Row gutter={16} align="middle">
              <Col sm={6}>
                <Form.Item name="companyName" label=" companyName">
                  <Input placeholder=" companyName" allowClear />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
        <Modal
          title="Create Client"
          visible={isModalOpen}
          onCancel={handleCancel}
          width={1000}
          footer={false}
        >
          <Form form={form} onFinish={submitHandler} layout="vertical">
            <Row gutter={16}>
              <Col sm={6}>
                <Form.Item
                  name="name"
                  label=" Name"
                  rules={[{ required: true, message: "Enter Name" }]}
                >
                  <Input placeholder=" Name" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="type"
                  label=" type"
                  rules={[{ required: true, message: "Enter type" }]}
                >
                  <Select placeholder="Select type">
                    <Select.Option value="client">Client</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="username"
                  label="username"
                  rules={[{ required: true, message: "Enter username" }]}
                >
                  <Input placeholder="username" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="password"
                  label="password"
                  rules={[{ required: true, message: "Enter password" }]}
                >
                  <Input.Password placeholder="password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="companyName"
                  label="companyName"
                  rules={[{ required: true, message: "Enter companyName" }]}
                >
                  <Input placeholder="companyName" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="client_email"
                  label="client_email"
                  rules={[
                    {

                      type: "email",
                      message: "Enter valid Email",
                    },
                  ]}
                >
                  <Input placeholder="client_email" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="email_password" label="email_password">
                  <Input.Password placeholder="email_password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="fb_username" label="fb_username">
                  <Input placeholder="fb_username" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="fb_password"
                  label="fb_password"

                >
                  <Input.Password placeholder="fb_password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="insta_username" label="insta_username">
                  <Input placeholder="insta_username" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item
                  name="insta_password"
                  label="insta_password"

                >
                  <Input.Password placeholder="insta_password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="linkedin_username" label="linkedin_username">
                  <Input placeholder="linkedin_username" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item
                  name="linkedin_password"
                  label="linkedin_password"

                >
                  <Input.Password placeholder="linkedin_password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="hostinger_username" label="hostinger_username">
                  <Input placeholder="hostinger_username" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="hostinger_password" label="hostinger_password">
                  <Input.Password placeholder="hostinger_password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="start_date"
                  label="start_date"
                  rules={[{ required: true, message: "Select start_date" }]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="end_date"
                  label="end_date"

                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item
                  name="address"
                  label="address"

                >
                  <Input.TextArea placeholder="address" />
                </Form.Item>
              </Col>

              <Col sm={6}>
                <Form.Item name="client_phone" label="Client Phone">
                  <Input placeholder="Client Phone" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="whatsapp_client_phone" label="whatsapp number">
                  <Input placeholder="whatsapp number" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="pincode" label="pincode">
                  <Input placeholder="pincode" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="domain_username" label="domain_username">
                  <Input placeholder="domain_username" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="domain_password" label="domain_password">
                  <Input.Password placeholder="domain_password" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="url" label="url">
                  <Input placeholder="url" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="wrokstatus" label="wrokstatus">
                  <Input placeholder="wrokstatus" />
                </Form.Item>
              </Col>
              <Col sm={6}>
                <Form.Item name="amount" label="amount">
                  <Input placeholder="amount" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    block
                  >
                    Create Client
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </div>

      <div>
        <DataTable
          dataSource={data}
          isLoading={isLoading}
          meta={meta}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total_count,
            onChange: (page: any, pageSize: any) => {
              setPage(page);
              setPageSize(pageSize);
            },
          }}
        />
      </div>
    </div>
  );
}

export default ClientIndex;
